var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Error',{attrs:{"icon":"cogs","title":"Maintenance in Progress","subtitle":"503: Service Unavailable"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }